module.exports = __webpack_public_path__ + "img/logo.e1bc3747.21bf62ca.png";